module.exports = __webpack_public_path__ + "img/logowebsiteiscoming.071ea114.jpg";